<template>
    <div class="title-component">
        <div class="row">
            <div class="col title">
                <h1>{{title}}</h1>
            </div>
        </div>
        <div class="row description">
            <div class="col">
                <h3>{{subtitle}}</h3>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'GuardianTitle',
        props: [
            'title',
            'subtitle'
        ]
    }
</script>

<style lang="scss" scoped>
    /*@media print {*/
        /*.title-component {*/
            /*padding-top: 50px;*/
            /*padding-bottom: 50px;*/
        /*}*/
        /*.title {*/
            /*font-family: 'alfa-regular', Arial, sans-serif;*/
            /*text-transform: uppercase;*/
        /*}*/
    /*}*/

    .description {
    }

</style>



// WEBPACK FOOTER //
// src/components/guardian/GuardianTitleComponent.vue